/**
 * Resolve workspace id for Workspace Pulse — URL param wins, then active workspace.
 * Avoids stale localStorage ids after login / workspace switch.
 */
export function resolveWorkspacePulseWorkspaceId({ searchParams, activeWorkspaceId, workspacesLoading, memberships }) {
    const fromUrl = searchParams?.get?.('workspace_id');
    if (fromUrl) {
        return String(fromUrl);
    }
    if (activeWorkspaceId) {
        return String(activeWorkspaceId);
    }
    if (!workspacesLoading && Array.isArray(memberships) && memberships.length === 1) {
        const onlyId = memberships[0]?.workspace?.id;
        return onlyId ? String(onlyId) : '';
    }
    return '';
}
